var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.source.basic)?_c('b-row',{style:(_vm.itemStyle)},[(_vm.source.vollerName)?_c('div',{staticClass:"card_new",on:{"click":function($event){return _vm.addToX(_vm.source.basic.kontaktID)}}},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.source.vollerName.anzeigeName))])])]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }